import { useLocalStorage } from '../hooks'

const SELECTION_TYPES = ['MULTIPLE_CHOICE', 'DROPDOWN', 'PICTURE']

export const parseRecallVariables = (shortId, value) => {
  const regex = /({{.*?}})+/g
  const recallVars = value?.match(regex)
  let renderString = value
  if (recallVars?.length) {
    const [submissions] = useLocalStorage('sub', {})
    const answers = submissions?.[shortId]?.answers

    recallVars.forEach((rv) => {
      const ffId = rv.match(/{{(.*?)}}/)?.[1]
      const answer = answers?.[ffId]
      const answerVal = SELECTION_TYPES.includes(answer?.type)
        ? answer?.optionValues.map((ov) => ov.text).join(', ')
        : answer?.value
      const recallVal = answerVal || ''
      renderString = renderString.replace(rv, recallVal)
    })
  }
  return renderString
}
